import { Loader2 } from 'lucide-react';

import { cx } from '@/lib/cx';

import styles from './Spinner.module.css';

type SpinnerProps = {
  size?: number;
  className?: string;
  /** Announced to screen readers. Pass null when a parent already says it. */
  label?: string | null;
};

export function Spinner({ size = 16, className, label = 'Loading' }: SpinnerProps) {
  return (
    <>
      <Loader2 size={size} className={cx(styles.spinner, className)} aria-hidden="true" />
      {label ? <span className="visually-hidden">{label}</span> : null}
    </>
  );
}
